import httpRequest from '@/utils/request'

// 修改当前用户密码
export function updatePwd(data: any): Promise<any> {
    return httpRequest({
        url: 'system/updatePwd',
        method: 'post',
        data
    })
}

// 切换当前公司级组织
export function changeCom(id: any): Promise<any> {
    return httpRequest({
        url: `ext/departmentExt/changeCom/${id}`,
        method: 'get'
    })
}

// 条件查询企业全部部门
export function getDepartmentListByConditon(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/departmentExt/getDepartmentListByConditon',
        method: 'post',
        data
    })
}
